var _path, _path2, _mask, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmergencyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 45,
    viewBox: "0 0 36 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.48389 33.7058V22.9639V15.9961C3.48389 7.97907 9.98298 1.47998 18 1.47998V1.47998C26.0171 1.47998 32.5161 7.97907 32.5161 15.9961V22.9639V33.7058",
    stroke: "black",
    strokeWidth: 2.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1765 6.12109V6.12109C25.0017 7.07739 27.8391 10.2964 28.3076 14.2114L28.4517 15.4155V19.48",
    stroke: "black",
    strokeWidth: 2.3,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_3232_1908",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 32.8345,
    width: 36,
    height: 11.6129,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 32.8345,
    width: 36,
    height: 11.6129,
    rx: 2,
    stroke: "black",
    strokeWidth: 4.6,
    mask: "url(#path-3-inside-1_3232_1908)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.8823,
    y: 9.82715,
    width: 4.23529,
    height: 13.7647,
    rx: 2.11765,
    fill: "#FFCC00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.8823,
    y: 25.7095,
    width: 4.23529,
    height: 4.23529,
    rx: 2.11765,
    fill: "#FFCC00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyIcon);
export default __webpack_public_path__ + "static/media/emergencyIcon.46534cf9e1e5b43006a0f0334ab3c443.svg";
export { ForwardRef as ReactComponent };